import { DateTime } from "luxon";

export const isWeekend = (date: DateTime) => {
  const { weekday } = date
  return weekday === 6 || weekday === 7
}